import { elementWithHeaderAndFooter } from "../../components/common/header/Header";
import PasswordResetView from "../../components/PasswordResetView";

export default function CurrentUserPasswordReset() {
    return elementWithHeaderAndFooter(<PasswordResetView resident={false} />, false);
}
